<template>
    <Menu as="div" class="relative flex-shrink-0">
        <div>
            <MenuButton
                class="p-0.5 rounded-full flex items-center text-sm hover:bg-minplan-lightgrey focus:outline-none space-x-2">
                <img v-if="user.profile_photo_url" :src="user.profile_photo_url" class="h-8 w-8 rounded-full object-cover border border-gray-200" :alt="user.firstname" />
                <CogIcon class="h-6 w-6 opacity-80" aria-hidden="true" />
            </MenuButton>
        </div>
        <transition enter-active-class="transition ease-out duration-100"
                    enter-from-class="transform opacity-0 scale-95"
                    enter-to-class="transform opacity-100 scale-100"
                    leave-active-class="transition ease-in duration-75"
                    leave-from-class="transform opacity-100 scale-100"
                    leave-to-class="transform opacity-0 scale-95">

            <MenuItems
                class="origin-top-right absolute right-0 mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none">
                <div class="block px-4 py-2 text-sm text-gray-700 border-b">
                    <strong>{{ $page.props.user.firstname }} {{ $page.props.user.lastname }}</strong>
                    <span v-if="$page.props.user.is_primary_owner" class="ml-2 px-2 inline-flex text-[10px] leading-4 font-semibold rounded-full bg-blue-100 text-blue-800 uppercase">
                        {{ $t('agencies.primaryOwner') }}
                    </span>
                </div>
                <MenuItem v-for="item in navigation" :key="item.name" v-slot="{ active } ">
                    <div
                        as="button"
                        class="w-full justify-start text-left cursor-pointer"
                        @click="navigate(item)"
                        :class="[active ? 'bg-gray-100' : '', 'block px-4 py-2 text-sm text-gray-700']">
                        {{
                            $t(item.name)
                        }}
                    </div>
                </MenuItem>
            </MenuItems>

        </transition>
    </Menu>

</template>

<script>
import { CogIcon } from "@heroicons/vue/outline";
import { Menu, MenuButton, MenuItem, MenuItems } from "@headlessui/vue";
import { Link } from "@inertiajs/inertia-vue3";
import { router } from "@inertiajs/inertia-vue3";
import { Inertia } from "@inertiajs/inertia";

const userNavigation = [
    { name: "navigation.profile", href: "user.profile.show", method: "get" },
    { name: "navigation.settings", href: "settings.index", method: "get" },
    { name: "navigation.logout", href: "logout", method: "post" }
];

const clientNavigation = [
    { name: "navigation.profile", href: "user.profile.show", method: "get" },
    { name: "navigation.logout", href: "logout", method: "post" }
];

export default {
    name: "UserNavigationDropdown",
    props: ["user"],
    components: {
        CogIcon,
        Menu,
        MenuButton,
        MenuItem,
        MenuItems,
        Link
    },
    setup(props) {
        let navigation = props.user.type === "advisor" ? userNavigation : clientNavigation;

        return {
            navigation
        };
    },
    methods: {
        navigate(item) {
            Inertia.visit(this.route(item.href), { method: item.method });
        }
    }
};
</script>

<style scoped>

</style>
